"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TGPieChart = void 0;
const react_1 = __importDefault(require("react"));
const pie_1 = require("@nivo/pie");
const lodash_1 = require("lodash");
const TGPieChart = (props) => (react_1.default.createElement(pie_1.ResponsivePie, Object.assign({}, props, { arcLabel: (datum) => `${lodash_1.floor(datum.value, 2)}`, margin: { top: 40, right: 80, bottom: 80, left: 80 }, innerRadius: 0.5, padAngle: 0.7, cornerRadius: 3, activeOuterRadiusOffset: 8, borderWidth: 1, borderColor: {
        from: 'color',
        modifiers: [
            [
                'darker',
                0.2
            ]
        ]
    }, arcLinkLabelsDiagonalLength: 24, arcLinkLabelsTextColor: "#333333", arcLinkLabelsThickness: 2, arcLinkLabelsColor: { from: 'color' }, arcLabelsSkipAngle: 10, arcLabelsTextColor: {
        from: 'color',
        modifiers: [
            [
                'darker',
                2
            ]
        ]
    }, legends: [
        {
            anchor: 'bottom',
            direction: 'row',
            justify: false,
            translateX: 0,
            translateY: 56,
            itemsSpacing: 0,
            itemWidth: 100,
            itemHeight: 18,
            itemTextColor: '#999',
            itemDirection: 'left-to-right',
            itemOpacity: 1,
            symbolSize: 18,
            symbolShape: 'circle',
            effects: [
                {
                    on: 'hover',
                    style: {
                        itemTextColor: '#000'
                    }
                }
            ]
        }
    ] })));
exports.TGPieChart = TGPieChart;
exports.default = exports.TGPieChart;
//# sourceMappingURL=TGPieChart.js.map